export default __webpack_public_path__ + "static/media/BK_97_QT_Header_2.bf46b977.png";